import { render, staticRenderFns } from "./basicInfoAgentDetail.vue?vue&type=template&id=0b08d51c&scoped=true"
import script from "./basicInfoAgentDetail.vue?vue&type=script&lang=js"
export * from "./basicInfoAgentDetail.vue?vue&type=script&lang=js"
import style0 from "./basicInfoAgentDetail.vue?vue&type=style&index=0&id=0b08d51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b08d51c",
  null
  
)

export default component.exports